export const CONSTANTS = {
  SCREEN_GROUP: 'admin',
  REQUEST_DELETE_IMAGE: 'request-delete-image',
  REQUEST_DOWNLOAD_IMAGE: 'request-download-image',
  REQUEST_UPLOAD_IMAGE: 'request-upload-image',
  REQUEST_CREATE_USER: 'request-create-user',
  REQUEST_UPDATE_USER: 'request-update-user',
  REQUEST_USER_DETAIL: 'request-user-detail',
  GRID_ADMIN_USER_LOOKUP: 'grid-admin-user-lookup',
} as const;
